module.exports = __webpack_public_path__ + "img/柑皮.514d5b5a.jpg";